/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { inventorySplit } from '../../axios/inventorySplit'
import type {
	InventorySplitError,
	InventorySplitPathParams,
	InventorySplitRequest,
	InventorySplitResponse,
} from '../../types/InventorySplit'

export const inventorySplitMutationKey = () => [{ url: '/:organisation/inventory/:item/split' }] as const

export type InventorySplitMutationKey = ReturnType<typeof inventorySplitMutationKey>

export type InventorySplitVariables = {
	organisation: InventorySplitPathParams['organisation']
	item: InventorySplitPathParams['item']
	data: InventorySplitRequest
}

/** @see backend/nexus/modules/Billing/Http/Controllers/InventoryController.php InventoryController::split */
export function useInventorySplit<TContext = unknown>(
	options?: UseMutationOptions<
		InventorySplitResponse,
		AxiosError<InventorySplitError>,
		InventorySplitVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: inventorySplitMutationKey(),
		mutationFn: ({ organisation, item, data }: InventorySplitVariables) =>
			inventorySplit(organisation, item, data, config).then(res => res.data),
		...options,
	})
}
